import { createFileRoute } from "@tanstack/react-router";

import AccountPanel from "@/components/Loyalty/AccountPanel";

const Component = () => {
  const { accountUuid } = Route.useParams();
  const { redemption } = Route.useSearch();
  // Keyed so moving between accounts starts with a closed modal and a fresh log.
  return (
    <AccountPanel
      key={accountUuid}
      accountUuid={accountUuid}
      highlightRedemptionUuid={redemption}
    />
  );
};

export const Route = createFileRoute("/gym/$venueUuid/loyalty/accounts/$accountUuid")({
  component: Component,
  // `redemption` highlights that redemption's transactions in the log, for links from the
  // redemptions log.
  validateSearch: (search: Record<string, unknown>): { redemption?: string } =>
    typeof search.redemption === "string" ? { redemption: search.redemption } : {},
});
